export function fileUpload() {
    document.querySelectorAll('input[type="file"].custom-upload').forEach(input => {
        const wrapper = document.createElement('div');
        wrapper.className = 'file-upload button';

        const label = document.createElement('span');
        label.className = 'file-upload-label';
        label.textContent = 'Browse';

        input.parentNode.insertBefore(wrapper, input);
        wrapper.appendChild(label);
        wrapper.appendChild(input);

        input.addEventListener('change', function () {
            if (this.files && this.files.length > 0) {
                label.textContent = this.files.length > 1
                    ? Array.from(this.files).map(f => f.name).join(', ')
                    : this.files[0].name;
            } else {
                label.textContent = 'Browse';
            }
        });
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/fileUpload.js